import { useNavigate } from 'react-router-dom';

const CH = {
  body:   'var(--mantine-color-body)',
  border: 'var(--app-color-border)',
  brand:  '#c96442',
  ink:    'var(--mantine-color-text)',
  dim:    '#87867f',
  serif:  '"Lora", Georgia, serif',
  mono:   'ui-monospace, monospace',
};

export const IconBtn = ({ children, onClick, style = {} }) => (
  <div onClick={onClick} style={{
    width: 36, height: 36, borderRadius: 8,
    display: 'flex', alignItems: 'center', justifyContent: 'center',
    color: CH.ink, cursor: 'pointer', flexShrink: 0,
    ...style,
  }}>{children}</div>
);

export const Logo = ({ size = 26 }) => (
  <img
    src="/cloudhub_logo.png"
    alt="CloudHub"
    style={{ width: size, height: size, borderRadius: 4, flexShrink: 0, display: 'block' }}
  />
);

// SVG アイコン
export const Icon = ({ d, size = 18 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth={1.75} strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

export const I = {
  home:    <Icon d="M3 10.5L12 3l9 7.5V21a1 1 0 01-1 1h-5v-7h-6v7H4a1 1 0 01-1-1V10.5z" />,
  back:    <Icon d="M19 12H5M12 19l-7-7 7-7" />,
  user:    <Icon d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2 M12 11a4 4 0 100-8 4 4 0 000 8z" />,
  logout:  <Icon d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4M16 17l5-5-5-5M21 12H9" />,
  search:  <Icon d="M21 21l-4.3-4.3M17 10a7 7 0 11-14 0 7 7 0 0114 0z" />,
  chevR:   <Icon d="M9 18l6-6-6-6" />,
  chevL:   <Icon d="M15 18l-6-6 6-6" />,
  chevD:   <Icon d="M6 9l6 6 6-6" />,
  dots:    <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor" stroke="none"><circle cx="5" cy="12" r="1.5"/><circle cx="12" cy="12" r="1.5"/><circle cx="19" cy="12" r="1.5"/></svg>,
  check:   <Icon d="M5 12l5 5L20 7" />,
  x:       <Icon d="M18 6L6 18M6 6l12 12" />,
  refresh: <Icon d="M3 12a9 9 0 0115.5-6.3L22 9M22 3v6h-6M21 12a9 9 0 01-15.5 6.3L2 15M2 21v-6h6" />,
  eye:     <Icon d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z M12 15a3 3 0 100-6 3 3 0 000 6z" />,
  play:    <svg width={18} height={18} viewBox="0 0 24 24" fill="currentColor" stroke="none"><path d="M6 4l14 8-14 8V4z"/></svg>,
  send:    <Icon d="M22 2L11 13M22 2l-7 20-4-9-9-4 20-7z" />,
  heart:   <Icon d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.7l-1-1.1a5.5 5.5 0 10-7.8 7.8l1 1 7.8 7.8 7.8-7.8 1-1a5.5 5.5 0 000-7.8z" />,
  reply:   <Icon d="M9 17l-5-5 5-5M4 12h12a4 4 0 014 4v4" />,
  plus:    <Icon d="M12 5v14M5 12h14" />,
  book:    <Icon d="M2 3h6a4 4 0 014 4v14a3 3 0 00-3-3H2V3zM22 3h-6a4 4 0 00-4 4v14a3 3 0 013-3h7V3z" />,
  settings:<Icon d="M12 15a3 3 0 100-6 3 3 0 000 6z M19.4 15a1.7 1.7 0 00.3 1.9l.1.1a2 2 0 11-2.9 2.9l-.1-.1a1.7 1.7 0 00-1.9-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 11-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.9.3l-.1.1a2 2 0 11-2.9-2.9l.1-.1a1.7 1.7 0 00.3-1.9 1.7 1.7 0 00-1.5-1H3a2 2 0 110-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.9l-.1-.1a2 2 0 112.9-2.9l.1.1a1.7 1.7 0 001.9.3h.1a1.7 1.7 0 001-1.5V3a2 2 0 114 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.9-.3l.1-.1a2 2 0 112.9 2.9l-.1.1a1.7 1.7 0 00-.3 1.9v.1a1.7 1.7 0 001.5 1H21a2 2 0 110 4h-.1a1.7 1.7 0 00-1.5 1z" />,
  external:<Icon d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6 M15 3h6v6 M10 14L21 3" />,
  award:   <Icon d="M12 15a7 7 0 100-14 7 7 0 000 14z M8.21 13.89L7 23l5-3 5 3-1.21-9.12" />,
};

function MobileAppHeader({ left, right, email }) {
  return (
    <div style={{
      position: 'sticky', top: 0, zIndex: 20,
      background: CH.body,
      borderBottom: `1px solid ${CH.border}`,
      padding: '8px 16px',
      display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      minHeight: 48,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>{left}</div>
      {email && (
        <div style={{
          fontFamily: CH.mono, fontSize: 11, color: CH.dim,
          maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
          flex: 1, textAlign: 'center', padding: '0 8px',
        }}>{email}</div>
      )}
      <div style={{ display: 'flex', alignItems: 'center', gap: 4 }}>{right}</div>
    </div>
  );
}

export { CH };
export default MobileAppHeader;
